import { useEffect, useState } from 'react';
import { apiRequests } from '../../shared/api/apiRequests';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Delete } from '../../features/DeleteEntity/index.js';
import { toast } from 'react-toastify';
import './Team.css';

const TeamGroupPage = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { structureId, id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    loadData();
  }, [structureId, id]);

  const loadData = () => {
    setLoading(true);
    apiRequests.team.getGroup(structureId, id).then((res) => {
      setData(res);
      setLoading(false);
    }).catch(() => {
      toast.error('Ошибка загрузки');
      setLoading(false);
    });
  };

  const handleDelete = (memberId) => {
    apiRequests.team.deleteMember(memberId).then(() => {
      toast.success('Участник удалён');
      setData((prev) => ({
        ...prev,
        members: prev.members.filter((i) => i.id !== memberId),
      }));
    }).catch(() => {
      toast.error('Ошибка удаления');
    });
  };

  if (loading) {
    return <div className="team-loading">Загрузка...</div>;
  }

  return (
    <div className="team-page">
      <div className="team-header">
        <div>
          <button className="team-back" onClick={() => navigate(`/team-structures/${structureId}`)}>
            ← Назад к группам
          </button>
          <h1 className="team-title">{data?.title || 'Группа'}</h1>
          <p className="team-subtitle">{data?.members?.length || 0} участников</p>
        </div>
        <Link to={`/team-structures/${structureId}/group/${id}/members/create`}>
          <button className="team-add-btn">+ Добавить участника</button>
        </Link>
      </div>

      {data?.members?.length === 0 ? (
        <div className="team-list">
          <div className="team-empty">Нет участников. Добавьте первого участника.</div>
        </div>
      ) : (
        <div className="team-members-grid">
          {data?.members?.map((member) => (
            <div key={member.id} className="team-member-card">
              <div className="team-member-card-header">
                <div className="team-member-card-avatar">
                  {member.thumbnailImgPath ? (
                    <img
                      src={member.thumbnailImgPath}
                      alt={`${member.name} ${member.surname}`}
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  ) : (
                    <span className="team-item-avatar-placeholder">👤</span>
                  )}
                </div>
                <div className="team-member-card-info">
                  <h3 className="team-member-card-name">{member.name} {member.surname}</h3>
                  <p className="team-member-card-position">{member.position}</p>
                </div>
              </div>
              {member.quote && (
                <p className="team-member-card-quote">"{member.quote}"</p>
              )}
              <div className="team-member-card-actions">
                <Link 
                  to={`/team-structures/${structureId}/group/${id}/members/${member.id}/edit`} 
                  className="team-btn-edit"
                >
                  Изменить
                </Link>
                <Delete onConfirm={() => handleDelete(member.id)} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TeamGroupPage;
